export default {
	finalize() {
		if ($('.module-portfolio').length === 0) {
			return false;
		}
		// Si le template de la page Portfolio est chargé
		if ($('.custom-template-portfolio')[0]) {
			// Applique le filtre associé à  chaque bouton
			$('.filter-wrapper > button').on('click', function () {
				// Change le style d'un bouton cliqué
				$('.filter-wrapper > button').removeClass('btn-terciary');
				$('.filter-wrapper > button').addClass('btn-terciary-unactive');
				$(this).addClass('btn-terciary');
				$(this).removeClass('btn-terciary-unactive');

				// Cache ou révèle les blocs associés à  un filtre
				var filter = $(this).attr('data-filter');
				$('.portfolio-item').hide();
				$('.' + filter).show();
				if (filter == 'all') {
					$('.portfolio-item').show();
				}
				orderPortfolioBloc(); // Organise les blocs
			});

			// Fonction pour organiser les blocs portfolio
			function orderPortfolioBloc() {
				var featuredBloc = [];
				var normalBloc = [];

				// Récupère les blocs normaux et mis en avant (featured) qui ne sont pas cachés
				$('.portfolio-item').each(function () {
					if ($(this).css('display') == 'block') {
						if ($(this).hasClass('featured-portfolio-item')) {
							featuredBloc.push($(this));
						} else {
							normalBloc.push($(this));
						}
					}
				});
				var featuredPosition = 'right';

				var counter = 0;

				// Itère chaque bloc avec l'étiquette featured_tag_name
				$(featuredBloc).each(function () {
					// Place le bloc featured à  droite et les autres normaux à  gauche
					if (featuredPosition == 'right') {
						$(this).removeClass('left_float');
						$(this).addClass('right_float');
						featuredPosition = 'left';

						var featured_wrapper = $(
							'<div class="featured_wrapper"></div>'
						);
						var normal_wrapper = $(
							'<div class="normal_wrapper"></div>'
						);

						for (var i = 0; i < 5; i++) {
							if (normalBloc[counter] && i < 2) {
								if (featuredPosition == 'left') {
									$(normalBloc[counter]).removeClass(
										'right_float'
									);
									$(normalBloc[counter]).addClass(
										'left_float'
									);
								} else {
									$(normalBloc[counter]).removeClass(
										'left_float'
									);
									$(normalBloc[counter]).addClass(
										'right_float'
									);
								}

								$(normalBloc[counter]).prependTo(
									featured_wrapper
								);
							} else if (normalBloc[counter] && i < 5) {
								$(normalBloc[counter]).prependTo(
									normal_wrapper
								);
							}
							counter++;
						}

						// Ajoute les div des blocs normaux et featured dans le wrapper portfolio
						$(featured_wrapper).insertAfter($(this));
						$(normal_wrapper).insertAfter($(featured_wrapper));
					} else {
						// Place le bloc featured à  gauche et les autres normaux à  droite
						$(this).removeClass('right_float');
						$(this).addClass('left_float');
						featuredPosition = 'right';

						var featured_wrapper = $(
							'<div class="featured_wrapper"></div>'
						);
						var normal_wrapper = $(
							'<div class="normal_wrapper"></div>'
						);

						for (var i = 0; i < 5; i++) {
							if (normalBloc[counter] && i < 2) {
								if (featuredPosition == 'right') {
									$(normalBloc[counter]).removeClass(
										'left_float'
									);
									$(normalBloc[counter]).addClass(
										'right_float'
									);
								} else {
									$(normalBloc[counter]).removeClass(
										'right_float'
									);
									$(normalBloc[counter]).addClass(
										'left_float'
									);
								}
								$(normalBloc[counter]).prependTo(
									featured_wrapper
								);
							} else if (normalBloc[counter] && i < 5) {
								$(normalBloc[counter]).prependTo(
									normal_wrapper
								);
							}
							counter++;
						}
						// Ajoute les div des blocs normaux et featured dans le wrapper portfolio
						$(featured_wrapper).insertAfter($(this));
						$(normal_wrapper).insertAfter($(featured_wrapper));
					}
				});
			}

			orderPortfolioBloc(); // Organise les blocs au chargement de la page
		} else {
			$('.module-portfolio').each(function () {
				var portfolioWrapper = $(this);
				console.log('haah');
				var indexSlide = 0;
				// Récupère les boutons suivant et précédent
				var next = portfolioWrapper.find('.slider-next-button');
				var prev = portfolioWrapper.find('.slider-prev-button');

				const intervalDuration = 7000;
				let portfolioScroll = 0;
				let myTimer = setInterval(changeSlide, intervalDuration);
				const circleNext = portfolioWrapper.find(
					'.slider-next-button .circle-countdown .circle'
				);

				circleNext.addClass('running');

				if (myTimer) {
					$('.portfolio-wrapper').on('touchmove', function () {
						if (myTimer) {
							disableAutoSlider();
						}
					});
				}

				// Au clique du bouton "suivant" le scroll s'anime vers le prochain wrapper
				next.on('click', function () {
					const isMobile = $(window).width() < 768;
					const easchItemtoMove = !isMobile
						? portfolioWrapper.find('.portfolio-grid')
						: portfolioWrapper.find('.portfolio-item');
					const wrapperWidth = easchItemtoMove.outerWidth();
					const portfolioScrollLive = portfolioWrapper
						.find('.portfolio-wrapper')
						.scrollLeft();
					indexSlide = Math.floor(portfolioScrollLive / wrapperWidth);

					disableAutoSlider();
					changeSlide();
				});

				// Au clique du bouton "précédent" le scroll s'anime vers le précédent wrapper
				prev.on('click', function () {
					const isMobile = $(window).width() < 768;
					const easchItemtoMove = !isMobile
						? portfolioWrapper.find('.portfolio-grid')
						: portfolioWrapper.find('.portfolio-item');
					const wrapperWidth = easchItemtoMove.outerWidth() + 10;
					const portfolioScrollLive = portfolioWrapper
						.find('.portfolio-wrapper')
						.scrollLeft();
					indexSlide = Math.round(portfolioScrollLive / wrapperWidth);

					disableAutoSlider();
					changeSlide(true);
				});

				function disableAutoSlider() {
					clearInterval(myTimer);
					myTimer = null;
					circleNext.removeClass('running');
				}

				function changeSlide(previous) {
					//automatic
					const isMobile = $(window).width() < 768;
					const portfolioScrollLive = portfolioWrapper
						.find('.portfolio-wrapper')
						.scrollLeft();
					if (
						portfolioScrollLive !== portfolioScroll &&
						myTimer &&
						!isMobile
					) {
						disableAutoSlider();
						return;
					}

					const easchItemtoMove = !isMobile
						? portfolioWrapper.find('.portfolio-grid')
						: portfolioWrapper.find('.portfolio-item');
					const gapSize = 10;
					const wrapperWidth = easchItemtoMove.outerWidth() + gapSize;
					const lastChild = !isMobile
						? portfolioWrapper.find('.portfolio-grid:last-child')
						: portfolioWrapper.find(
								'.portfolio-grid:last-child .portfolio-item:last-child'
						  );
					const lastChildLeft = lastChild.position().left;

					if (!previous) {
						if (lastChildLeft < 10) {
							indexSlide = 0;
						} else {
							indexSlide++;
						}
					} else {
						indexSlide =
							indexSlide === 0
								? easchItemtoMove.length - 1
								: indexSlide - 1;
					}

					circleNext.removeClass('running');
					circleNext[0].offsetHeight; //forces reflow
					if (myTimer) {
						circleNext.addClass('running');
					}
					portfolioWrapper
						.find('.portfolio-wrapper')
						.animate(
							{ scrollLeft: wrapperWidth * indexSlide },
							1000,
							'swing',
							function () {
								portfolioScroll = $(this).scrollLeft();
							}
						);
				}

				$(document).ready(function () {
					const ele = portfolioWrapper.find('.portfolio-wrapper')[0];
					const circleNext = portfolioWrapper.find(
						'.slider-next-button .circle-countdown .circle'
					);
					const circlePrev = portfolioWrapper.find(
						'.slider-prev-button .circle-countdown .circle'
					);

					let pos = { top: 0, left: 0, x: 0, y: 0 };

					const mouseDownHandler = function (e) {
						pos = {
							left: ele.scrollLeft,
							top: ele.scrollTop,
							// Get the current mouse position
							x: e.clientX,
							y: e.clientY,
						};

						//document.addEventListener('mousemove', mouseMoveHandler);
						ele.addEventListener('scroll', onFolioScroll);
						ele.addEventListener('mouseup', mouseUpHandler);
					};

					const mouseUpHandler = function () {
						ele.removeEventListener('scroll', onFolioScroll);
						ele.removeEventListener('mouseup', mouseUpHandler);
					};

					const onFolioScroll = function () {
						//onScroll : reset timer and circle animation
						circleNext.removeClass('running');
						circlePrev.removeClass('running');

						if (myTimer) {
							//clear up timer, will enable it back in mouseUpHandler
							clearInterval(myTimer);
							myTimer = null;
						}
					};

					// Attach the handler
					ele.addEventListener('mousedown', mouseDownHandler);

					// reset timer when portfolio goes out of viewport
					$(window).on('scroll', function () {
						if (
							($(document).scrollTop() >
								$('.module-portfolio').eq(0).offset().top +
									$('.module-portfolio')
										.eq(0)
										.outerHeight() ||
								$(document).scrollTop() <
									$('.module-portfolio').eq(0).offset()
										.top) &&
							!myTimer
						) {
							//RESET SLIDER BACK TO 0
							myTimer = 'tempValue';
							indexSlide = 0; //reset index Slide
							portfolioWrapper
								.find('.portfolio-wrapper')
								.eq(0)
								.animate(
									{ scrollLeft: 0 },
									{
										duration: 200,
										complete: function () {
											myTimer = setInterval(
												changeSlide,
												intervalDuration
											); // reset timer
											circleNext.addClass('running'); //add animation on circle icons
										},
									}
								); //put scrollLeft back to 0, so we start from begining of slider
						}
					});
				});
			});
		}
	},
};
